module.exports = __webpack_public_path__ + "static/media/coffee.8c2c9ec3.png";